import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { ShowMore } from '#components/ShowMore';
import { RichText } from '../base/RichtText/RichtText';
import styles from './AuthorHeader.module.scss';
import { AuthorHeaderSocialMediaAccounts } from './AuthorHeaderSocialMediaAccounts';
import type { AuthorHeaderFragment } from './__generated__/AuthorHeader.generated';
import DefaultAuthorImage from './default-author-image.svg';
type Props = Omit<AuthorHeaderFragment, '__typename'> & {
  name: string | null;
};
export function AuthorHeader(t0) {
  const $ = _c(25);
  const {
    description,
    jobTitle,
    name,
    profilePicture,
    socialMediaAccounts
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = description !== "<p></p>" && description ? <ShowMore as="section" minimizedHeight={120}><RichText className={`${styles.description} body1`} text={description} /></ShowMore> : null;
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const desc = t1;
  const t2 = name ?? "";
  const t3 = name ?? undefined;
  const t4 = profilePicture ? profilePicture : DefaultAuthorImage;
  const t5 = !profilePicture;
  let t6;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = <section className={styles.profilePictureSection}><Image className={styles.profilePicture} height={160} width={160} alt={t2} title={t3} src={t4} unoptimized={t5} /></section>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== name) {
    t7 = <h2 className="heading1">{name}</h2>;
    $[7] = name;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== jobTitle) {
    t8 = !!jobTitle && <h3>{jobTitle}</h3>;
    $[9] = jobTitle;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className={styles.informationHeader}>{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== desc) {
    t10 = <div className="body1">{desc}</div>;
    $[14] = desc;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== socialMediaAccounts) {
    t11 = <AuthorHeaderSocialMediaAccounts socialMediaAccounts={socialMediaAccounts} />;
    $[16] = socialMediaAccounts;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <section className={styles.informationSection}>{t9}{t10}{t11}</section>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t6) {
    t13 = <address className={styles.wrapper}>{t6}{t12}</address>;
    $[22] = t12;
    $[23] = t6;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}